/**
 * Utility for pluralizing a word.
 * Returns and 's' unless the number is 1.
 */
export default function plural(n: number, word = '') {
  const suffix = n === 1 ? '' : 's';
  const wordSingular = word.replace(/s$/, '');
  return wordSingular + suffix;
}
